(() => {
  const desktopMediaQuery = window.matchMedia('(min-width: 768px)');
  const mediaShiftRem = 9;
  const mediaTopGap = 64;
  const blockerGap = 16;

  const getVisibleBottom = (selector) => {
    const elements = Array.from(document.querySelectorAll(selector));
    const visibleBottoms = elements
      .filter((element) => element instanceof HTMLElement && element.offsetParent !== null && !element.hidden)
      .map((element) => element.getBoundingClientRect())
      .filter((rect) => rect.height > 0 && rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight)
      .map((rect) => rect.bottom);

    return visibleBottoms.length ? Math.max(...visibleBottoms) : 0;
  };

  const getTopBoundary = () => {
    const headerBottom = getVisibleBottom(
      '#shopify-section-header, .shopify-section-header-sticky, .section-header, header-component, header'
    );
    const promoBottom = getVisibleBottom('.pdp-promo-bar:not([hidden])');
    const menuBoundary =
      (headerBottom || parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0) +
      mediaTopGap;

    if (promoBottom > 0) {
      return Math.max(menuBoundary, promoBottom + blockerGap);
    }

    return menuBoundary;
  };

  const getStartFixAt = (wrapperAbsTop, minTop) => Math.max(wrapperAbsTop - minTop, 0);

  const initSection = (section) => {
    const mediaWrappers = Array.from(section.querySelectorAll('.product__media-wrapper'));
    const mediaWrapper = mediaWrappers.find((wrapper) => wrapper.offsetParent !== null);
    const mediaPin = mediaWrapper?.querySelector('[data-product-media-pin]');
    const infoWrapper = section.querySelector('.product__info-wrapper');
    if (!mediaWrapper || !mediaPin || !infoWrapper) return;

    let metrics = null;
    const reset = () => {
      metrics = null;
      mediaWrapper.style.minHeight = '';
      mediaPin.classList.remove('is-fixed', 'is-stuck-bottom');
      mediaPin.style.removeProperty('--product-media-pin-left');
      mediaPin.style.removeProperty('--product-media-pin-offset-left');
      mediaPin.style.removeProperty('--product-media-pin-width');
      mediaPin.style.removeProperty('--product-media-safe-top');
      mediaPin.style.removeProperty('--product-media-pin-top');
      mediaPin.style.removeProperty('--product-media-pin-stop');
    };

    const measure = () => {
      if (!desktopMediaQuery.matches) {
        reset();
        return;
      }

      const mediaShift = mediaShiftRem * (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16);
      const wrapperRect = mediaWrapper.getBoundingClientRect();
      const infoHeight = infoWrapper.offsetHeight;
      const scrollTop = Math.max(window.scrollY || window.pageYOffset, 0);
      const wrapperTop = scrollTop + wrapperRect.top;
      const infoBottom = scrollTop + infoWrapper.getBoundingClientRect().bottom;
      const minTop = getTopBoundary();
      mediaPin.classList.add('is-fixed');
      const pinHeight = mediaPin.offsetHeight;

      mediaWrapper.style.minHeight = `${Math.max(infoHeight, pinHeight)}px`;
      mediaPin.style.setProperty('--product-media-pin-left', `${wrapperRect.left - mediaShift}px`);
      mediaPin.style.setProperty('--product-media-pin-offset-left', `${-mediaShift}px`);
      mediaPin.style.setProperty('--product-media-pin-width', `${wrapperRect.width}px`);
      mediaPin.style.setProperty('--product-media-safe-top', `${minTop}px`);
      mediaPin.style.setProperty('--product-media-pin-top', `${minTop}px`);
      mediaPin.style.setProperty('--product-media-pin-stop', `${Math.max(infoBottom - wrapperTop - pinHeight, 0)}px`);

      metrics = {
        startFixAt: getStartFixAt(wrapperTop, minTop),
        stopFixAt: Math.max(infoBottom - minTop - pinHeight, getStartFixAt(wrapperTop, minTop)),
        wrapperAbsTop: wrapperTop,
        infoBottom,
        pinHeight,
        minTop,
      };
    };

    const update = () => {
      if (!desktopMediaQuery.matches) {
        reset();
        return;
      }

      if (!metrics) {
        measure();
        if (!metrics) return;
      }

      const minTop = getTopBoundary();

      metrics.minTop = minTop;
      mediaPin.style.setProperty('--product-media-safe-top', `${minTop}px`);
      mediaPin.style.setProperty('--product-media-pin-top', `${minTop}px`);
      metrics.startFixAt = getStartFixAt(metrics.wrapperAbsTop, minTop);
      metrics.stopFixAt = Math.max(
        metrics.infoBottom - minTop - metrics.pinHeight,
        getStartFixAt(metrics.wrapperAbsTop, minTop)
      );

      mediaPin.classList.add('is-fixed');
    };

    let rafId = null;
    const requestUpdate = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        update();
      });
    };

    const requestMeasureAndUpdate = () => {
      metrics = null;
      requestUpdate();
    };

    const resizeObserver = new ResizeObserver(requestMeasureAndUpdate);
    resizeObserver.observe(section);
    resizeObserver.observe(mediaWrapper);
    resizeObserver.observe(infoWrapper);

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestMeasureAndUpdate);
    desktopMediaQuery.addEventListener('change', requestMeasureAndUpdate);
    document.addEventListener('shopify:section:load', requestMeasureAndUpdate);
    document.addEventListener('shopify:section:reorder', requestMeasureAndUpdate);

    requestMeasureAndUpdate();
  };

  const init = () => {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
